import React, { Component, Fragment } from "react";
import { axiosPost } from "../apis/useAxios";
import axios from "axios";
import {
  ClearSessionItems,
  LocalStorage,
  getCachedLocation,
} from "../helper/appsession";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { LoginAssetType } from "../helper/fixcode";
import { LogoutLoader } from "./Shared/PageLoader";

export class SideBarComponent extends Component {
  static displayName = SideBarComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      userFeatureSetup: JSON.parse(LocalStorage.UserFeatureSetup || "[]"),
      roleSetup: null,
      isLoading: false,
      expandedMenuId: null,
    };
  }

  async componentDidMount() {
  }

  toggleMenu = (featureId) => {
    this.setState((prev) => ({
      expandedMenuId: prev.expandedMenuId === featureId ? null : featureId,
    }));
  };

  getMenuHtml(menuFeature, expandedMenuId) {
    let menuHtmlItem = [];
    menuFeature = JSON.parse(JSON.stringify(menuFeature));
    menuFeature?.forEach((menu) => {
      if (menu.parentFeatureId === 0) {
        let childMenu = menuFeature.filter(
          (el) => el.parentFeatureId === menu.featureId
        );
        const menuName = menu.displayName;
        if (childMenu.length > 0) {
          const isOpen = expandedMenuId === menu.featureId;
          menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div className="card-header nav-link" id={"faqhead" + menu.featureId}>
                <a
                  href="#"
                  className={"nav-link" + (isOpen ? "" : " collapsed")}
                  onClick={(e) => { e.preventDefault(); this.toggleMenu(menu.featureId); }}
                  aria-expanded={isOpen}
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p>{menuName}</p>
                </a>
              </div>
              <div style={{ display: isOpen ? "block" : "none" }}>
                <div className="card-body p-0">
                  <ul className="nav nav-treeview">
                    {this.subMenuHtml(childMenu)}
                  </ul>
                </div>
              </div>
            </div>
          );
           //
        } else if (menuName === "GPS Tracking") {
          LocalStorage.TrackingGuid !== "00000000-0000-0000-0000-000000000000" && 
          (menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div id={"faqhead" + menu.featureId}>
                <a
                  href="#"
                  onClick={(e) => {
                    this.redirectToTracking(e);
                  }}
                  className="nav-link"
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p>{menu.displayName}</p>
                </a>
              </div>
            </div>
          ));
        } else if (menuName === "Leads") {
          menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div id={"faqhead" + menu.featureId}>
                <a
                  onClick={(e) => {
                    window.history.replaceState(null, null, "/");
                    window.location.href = "/leads";
                  }}
                  className="nav-link"
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p>{menu.displayName}</p>
                </a>
                <Link
                  to={{
                    pathname: "/leads",
                    state: { TabId: 0 },
                  }}
                ></Link>
              </div>
            </div>
          );
        } else if (menuName === "Ticket") {
          menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div id={"faqhead" + menu.featureId}>
                <a
                  href="https://ticketing.utwiz.com/"
                  target="_new"
                  className="nav-link"
                >
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p>{menu.displayName}</p>
                </a>
              </div>
            </div>
          );
        } else {
          menuHtmlItem.push(
            <div className="card" key={menu.featureId}>
              <div id={"faqhead" + menu.featureId}>
                <Link to={"/" + menu.requestPath.replace(/^\//, "")} className="nav-link">
                  <Icon icon={menu.iconName} className="nav-icon" />
                  <p>{menu.displayName}</p>
                </Link>
              </div>
            </div>
          );
        }
      }
    });
    return menuHtmlItem;
  }

  subMenuHtml = (menuFeature) =>
    menuFeature.map((subchild) => (
      <div className="card" key={subchild.featureId}>
        <div id={"faqhead" + subchild.featureId}>
          <Link
            to={"/" + subchild.requestPath.replace(/^\//, "")}
            className="nav-link"
            title={subchild.displayName}
          >
            <Icon icon={subchild.iconName} className="nav-icon" />
            <p>{subchild.displayName}</p>
          </Link>
        </div>
      </div>
    ));

  handleOnLogout = async (e) => {
    e.preventDefault();
    try {
      this.setState({
        isLoading: true,
      });
      const { lat, lng } = getCachedLocation();
      await axiosPost(
        `/authenticate/logout?userId=${LocalStorage.UserId}`,
        { SessionId: LocalStorage.SessionId, AssetTypeId: LoginAssetType.Web, Latitude: lat, Longitude: lng },
        { timeout: 3000 },
      );
      window.ameyo?.integration?.doLogout?.();
    } catch (error) {
      console.log(error);
    }
    const wasSsoLogin = sessionStorage.getItem("session_sso_login") === "true";
    ClearSessionItems();
    window.location.href = wasSsoLogin
      ? `${process.env.REACT_APP_PORTAL_URL || ""}/logout`
      : "/";
  };

  redirectToTracking = async (e) => {
    e.preventDefault();
    this.setState({ loadPanelVisible: true });
    try {
      const redirectdata = await axiosPost(process.env.REACT_APP_CUSTOMER_API_URL + "RedirectUser/external-token", {
        Source: "zenplus",
        Token: LocalStorage.TrackingGuid,
      });

      if (redirectdata.isSuccess) {
        this.setState({ loadPanelVisible: false });
        if (redirectdata.payload != null) {
          window.open(
            process.env.REACT_APP_CUSTOMER_SITE_URL +
            "?userguid=" +
            LocalStorage.TrackingGuid +
            "&source=zenplus",
            "_blank"
          );
        } 
        // else if (redirectdata.token != null) {
        //   window.open(
        //     process.env.REACT_APP_CUSTOMER_SITE_URL +
        //     "?userguid=" +
        //     redirectdata.token +
        //     "&source=zenplus",
        //     "_blank"
        //   );
        // }
      }

      // const redirectdata = await axios
      //   .request(
      //     process.env.REACT_APP_CUSTOMER_API_URL +
      //       `RedirectUser/external-token/${LocalStorage.UserName}`
      //   )
      //   .then((res) => res.data)
      //   .catch((err) => {})
      //   .finally(() => {});

      
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleUserSubmit function",
        err
      );
      this.setState({ loadPanelVisible: false });
    }
  };
  render() {
    return (
      <Fragment>
        <div className="main-sidebar">
          <aside className="main-sidebar sidebar-dark-primary elevation-4">
            {/* <a href="/" className="brand-link">
              <img
                src="dist/img/utwiz-icon.png"
                alt="AdminLTE Logo"
                className="brand-image img-circle elevation-3"
                style={{ opacity: ".8" }}
              />
              <span className="brand-text font-weight-light">
                <img
                  src="dist/img/utiwiz-logo-light.png"
                  alt="AdminLTE Logo"
                  className="brand-image1"
                />
              </span>
            </a> */}
            <a href="/" className="brand-link">
              <img
                src="dist/img/fleetpro-icon.png"
                alt="Fleet Pro"
                className="brand-image img-circle elevation-3"
                style={{ opacity: "none" }}
              />
              <span className="brand-text font-weight-light">
                <img
                  src="dist/img/fleet-pro-white.svg"
                  alt="Fleet Pro"
                  className="brand-image2"
                />
              </span>
            </a>
            {/* <div className="user-panel mt-2 pb-2 mb-2 d-flex">
              <div className="image">
                <img src="dist/img/avatar5.png" className="img-circle elevation-2" alt="User Image" />
              </div>
              <div className="info">
                <a href="#" className="d-block" style={{paddingLeft: "20px;"}}>{LocalStorage.UserName}!</a>
              </div>
            </div> */}
            <div className="sidebar">
              <div id="main">
                <div className="accordion" id="faq">
                  {/* <div className="card">
                      <Link to="/home" className="nav-link">
                        <Icon icon="material-symbols:dashboard-outline" width="24" height="24" className="nav-icon" />
                        <p>Dashboard</p>
                      </Link>
                  </div>
                  <div className="card">
                      <Link to="/addleads" className="nav-link">
                        <Icon icon="gridicons:add-outline" width="24" height="24" className="nav-icon"/>
                        <p>Leads</p>
                      </Link>
                  </div>
                  <div className="card">
                      <Link to="/schememaster" className="nav-link">
                        <Icon icon="fluent-mdl2:diet-plan-notebook" width="24" height="24" className="nav-icon"/>
                        <p>Scheme</p>
                      </Link>
                  </div> */}
                  {this.getMenuHtml(this.state.userFeatureSetup, this.state.expandedMenuId)}
                  <div className="card">
                    <div id="faqhead100">
                      <a
                        href="#"
                        className="nav-link"
                        onClick={(e) => this.handleOnLogout(e)}
                      >
                        <i className="fas fa-sign-out-alt nav-icon"></i>
                        <p>Logout</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
        {this.state.isLoading && <LogoutLoader />}
      </Fragment>
    );
  }
}
